import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import React, { useEffect } from "react";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import HttpService from "../../../hooks/Https-services";
import { APIRoutes } from "../../../utils/constants";
import { toast } from "react-toastify";
const LikeDisLike = ({ currentVideo, videoStats, getVideoStats }: any) => {
  const [alignment, setAlignment] = React.useState<string | null>("");
  const [loading, setLoading] = React.useState(false);
  const handleAlignment = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null
  ) => {
    LikeDisLikeFun(newAlignment);

    setAlignment(newAlignment);
  };
  const LikeDisLikeFun = async (newAlignment: string | null) => {
    try {
      setLoading(true);
      const res = await HttpService.post(
        APIRoutes.LikeDisLike.replace(":entity_id", currentVideo?.ID).replace(
          ":entity_name",
          "wizzard"
        ),
        {
          reaction: !newAlignment ? 0 : parseInt(newAlignment),
        }
      );
      getVideoStats();
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (videoStats?.Reaction === 1 || videoStats?.Reaction === 2) {
      setAlignment(videoStats?.Reaction.toString());
    } else {
      setAlignment("0");
    }
  }, [videoStats]);

  return (
    <Box>
      <ToggleButtonGroup
        size="small"
        value={alignment}
        exclusive
        disabled={loading}
        onChange={handleAlignment}
        aria-label="text alignment"
        color="primary"
        sx={{
          ".MuiToggleButtonGroup-grouped:not(:last-of-type)": {
            borderTopLeftRadius: "50px",
            borderBottomLeftRadius: "50px",
          },
          ".MuiToggleButtonGroup-grouped:not(:first-of-type)": {
            borderTopRightRadius: "50px",
            borderBottomRightRadius: "50px",
          },
          ".MuiToggleButtonGroup-grouped": {
            py: "5px",
          },
        }}
      >
        <ToggleButton value="1" aria-label="left aligned">
          <ThumbUpOffAltIcon />{" "}
          {videoStats?.LikesCount > 0 && videoStats?.LikesCount} Likes
        </ToggleButton>
        <ToggleButton value="2" aria-label="centered">
          <ThumbDownOffAltIcon />
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};
export default LikeDisLike;
